import { render, staticRenderFns } from "./energySaved.vue?vue&type=template&id=7b9cd942&scoped=true"
import script from "./energySaved.vue?vue&type=script&lang=js"
export * from "./energySaved.vue?vue&type=script&lang=js"
import style0 from "./energySaved.vue?vue&type=style&index=0&id=7b9cd942&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9cd942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9cd942')) {
      api.createRecord('7b9cd942', component.options)
    } else {
      api.reload('7b9cd942', component.options)
    }
    module.hot.accept("./energySaved.vue?vue&type=template&id=7b9cd942&scoped=true", function () {
      api.rerender('7b9cd942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/energySaved.vue"
export default component.exports